<owl-carousel-child #owl [ngClass]="carouselClasses" [options]="options" ><ng-content></ng-content></owl-carousel-child>